import * as React from 'react'

import('./VideoOverlayStyles.scss')   


const VideoOverlayPresentation = function VideoOverlay(props:any) {
    return (
        <div className={`videoOverlayContainer ${isHidden(!props.visible)}`}>
            <div className={`videoOverlay`}>
                {props.children}
            </div>
        </div>
    )
}

// returns a stric hidden if the boolean is true
const isHidden = (hidden:boolean) => hidden ? 'hidden' : ''

export default VideoOverlayPresentation
